import { buildAboutBlocksFromForm } from './aboutContentTransform';
import { buildPackageExtrasPayload } from './packageExtrasContentTransform';

export { parseAboutFormFromRecord, buildAboutBlocksFromForm } from './aboutContentTransform';
export { parsePackageExtrasFormFromRecord } from './packageExtrasContentTransform';

type TimelineFormSource = {
  getFieldValue?: (name: string) => unknown;
};

export function buildContentManagementPayload(
  values: any,
  form?: TimelineFormSource,
  options?: {
    includePopularServices?: boolean;
    includeRelatedArticles?: boolean;
  },
) {
  const mergedValues = {
    ...values,
    timelineName: values.timelineName ?? form?.getFieldValue?.('timelineName'),
    timelineTable: values.timelineTable ?? form?.getFieldValue?.('timelineTable'),
  };

  const extras = buildPackageExtrasPayload(mergedValues);
  const includePopularServices = options?.includePopularServices === true;

  if (!includePopularServices) {
    delete (extras as { popularServicesSection?: unknown }).popularServicesSection;
  }
  if (options?.includeRelatedArticles !== true) {
    delete (extras as { relatedArticlesSection?: unknown }).relatedArticlesSection;
  }

  return {
    headingTitle: mergedValues.headingTitle?.trim() || null,
    headingDescription: mergedValues.headingDescription?.trim() || null,
    stepsHeading: mergedValues.stepsHeading?.trim() || null,
    stepsSubtitle: mergedValues.stepsSubtitle?.trim() || null,
    timelineName: mergedValues.timelineName?.trim() || null,
    timelineTable: Array.isArray(mergedValues.timelineTable)
      ? mergedValues.timelineTable
      : [],
    steps: (mergedValues.steps || []).map((step: any, index: number) => ({
      sequence: index + 1,
      description: step.description,
    })),
    process: mergedValues.aboutDescription || '',
    aboutHeading: mergedValues.aboutHeading || {},
    aboutBlocks: buildAboutBlocksFromForm(mergedValues),
    ...extras,
    faqs: (mergedValues.faqs || []).map((faq: any, index: number) => ({
      sequence: index + 1,
      question: faq.question,
      answer: faq.answer,
      answerFormat: faq.answerFormat || 'text',
      checklistItems: (faq.checklistItems || []).filter(Boolean),
    })),
    isActive: mergedValues.isActive !== false,
  };
}

export function getTimelineFormValues(values: any, form?: TimelineFormSource) {
  return {
    timelineName: values.timelineName ?? form?.getFieldValue?.('timelineName'),
    timelineTable: values.timelineTable ?? form?.getFieldValue?.('timelineTable'),
  };
}

export const buildProcessFaqContentPayload = buildContentManagementPayload;
